import BulkCreateBrandModelSelect from './bulkCreateBrandModelSelect.container';

export default BulkCreateBrandModelSelect